import React from 'react';
import { Link } from 'react-router-dom'

const Team2 = (props) => {

    const data = props.data;

    return (
        <section className="tf-section team">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="block-text center">
                            <h1 className="heading-bg" data-aos="fade-in" data-aos-duration="1000"><span>Team</span></h1>
                            <h5 className="sub-title mb-10" data-aos="fade-up" data-aos-duration="1000">Team Members</h5>
                            <h3 className="title mb-28" data-aos="fade-up" data-aos-duration="1000">Our Amazing Team </h3>
                        </div>
                    </div>
                </div>
                <div className="row mt-61">
                    {
                        data.slice(0,2).map((data,index) => (
                            <div key={index} className="col mt-48 col mt-48">
                                <div className="team-box-2" data-aos="fade-up" data-aos-duration="800">
                                    <div className="img-team">
                                        <img src={data.img} alt="SkunkzNFT" />
                                        <div className="social">
                                            <p>
                                                <br></br>
                                            <li data-aos="fade-up" data-aos-duration="1000"><a href={data.telegram} target="_blank"><i className="fab fa-telegram fa-3x"></i></a></li>
                                            <br></br>
                                            <li data-aos="fade-up" data-aos-duration="1000"><a href={data.twitter} target="_blank"><i className="fab fa-twitter fa-3x"></i></a></li>
                                             
                                            </p>
                                        </div>
                                    </div>
                                    <div className="team-info">
                                        <Link to="#" className="h5">{data.name}</Link>
                                        <p className="fs-16">{data.position}</p>
                                    </div>
                                </div>
                            </div>
                        ))
                    }

                    
                </div>
                
            </div>
        </section>
    );
}

export default Team2;